const parseHippoEvent = event => {
  const TOKEN_REGEX = /\/video\/play\/(.+)$/g;
  return TOKEN_REGEX.exec(event.recorded_url)[1];
};

export default parseHippoEvent;
